<template>
<v-layout class="no-pages" wrap >
  <v-flex
    xs12
    class="textAlert"
    style="padding:10%;height: 1080px;"
  >
    <v-layout class="no-pages" wrap style="height:100%">
      <v-flex
        xs12
        class="textAlert"
        style="padding:100px;height: 100%;background-size: cover;"
        :style="{ 'background-image': bgimg, color: color1 }"
      >
        <center v-if="!hidemsg"><b>NO HAY MÁS ACTIVIDADES PROGRAMADAS<br>PARA EL DÍA</b></center>
      </v-flex>
    </v-layout>
  </v-flex>
 </v-layout>
</template>
<script>
import utils from '@/services/utils'
export default {
  computed: {
    color1 () {
      return utils.getParameterByName('c1') ? '#'.concat(utils.getParameterByName('c1')) : '#02443C'
    },
    hidemsg () {
      return utils.getParameterByName('hidemsg')
    },
    bgimg () {
      const bg = utils.getParameterByName('bgimg')
      return bg ? `url(https://www.dviewcontent.com/activity/acttiv/images/backgrounds/${bg}.png)` : null
    }
  },
}
</script>
<style scoped>
.no-pages.layout.wrap {
  padding: 0  !important;
}
</style>

